/**
 * Removes i18n locale suffixes from route names
 * @param routeName - Route name, may be undefined or a symbol
 * @returns Clean route name without locale suffixes, or an empty string
 */
export function useCleanRouteName(routeName: unknown): string {
  // route.name can be undefined or a symbol, e.g. when the rendered page does not match the URL
  return typeof routeName === 'string' ? routeName.replace(/___.+$/, '') : ''
}
